export default __webpack_public_path__ + "static/media/profilepic.b2111f46.png";